export const CompanyName = "Electura";
export const PhoneNumber = "+91-98765 43210";
